import React, { useState } from 'react';
import { FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';
import SEO from '../components/SEO';
import '../styles/Contact.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://us-central1-bularistech-8bf5f.cloudfunctions.net/api';

const Contact = () => {
  const [formState, setFormState] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSending, setIsSending] = useState(false);

  const handleChange = (event) => {
    setFormState((current) => ({ ...current, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSending(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await fetch(`${API_URL}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formState),
      });
      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Unable to send your message');
      }

      setFormState({ name: '', email: '', message: '' });
      setStatus({ type: 'success', message: 'Your message was received. We will reply soon.' });
    } catch (error) {
      setStatus({ type: 'error', message: error.message });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <main className="contact-page">
      <SEO
        title="Contact Bularis Tech | Discuss Your Project"
        description="Contact Bularis Tech to discuss software, e-commerce, Shopify, integrations, automation, or a custom technical requirement."
        path="/contact"
      />
      <section className="contact-hero"><div className="contact-hero-container"><span>Start a conversation</span><h1>Let’s Talk About What You Want to Build</h1><p>Whether it involves software, e-commerce, an integration, automation, or a custom technical requirement, tell us what you want to improve.</p></div></section>
      <section className="contact-main"><div className="contact-layout">
        <div className="contact-information">
          <span className="contact-eyebrow">How we can help</span><h2>Bring us the project—or the problem</h2><p>You do not need to have the technical solution defined. Share the goal, current challenge, or workflow that is getting in the way.</p>
          <ul className="contact-topics"><li>Web and software development</li><li>E-commerce and Shopify</li><li>API and payment integrations</li><li>AI voice automation and telephony workflows</li><li>Products, demonstrations, and custom technical requirements</li></ul>
          <div className="contact-details"><h3>Connect with Bularis Tech</h3><a href="https://wa.me/14376043134" target="_blank" rel="noopener noreferrer"><FaWhatsapp /><span>WhatsApp</span></a><address><FaMapMarkerAlt /><span>16 Alphonse Crescent, Mississauga, Ontario L5M 1A5, CA</span></address><address><FaMapMarkerAlt /><span>201 Exford Rd, Weir Views VIC 3338 Australia</span></address></div>
        </div>
        <div className="contact-form-panel">
          <div className="contact-form-heading"><span>Project inquiry</span><h2>Tell us what you’re working on</h2><p>Provide a little context and we’ll have a useful starting point for the conversation.</p></div>
          <form className="contact-form" onSubmit={handleSubmit} aria-describedby={status.message ? 'contact-form-status' : undefined}>
            <div className="contact-field"><label htmlFor="contact-name">Name</label><input id="contact-name" type="text" name="name" placeholder="Your name" autoComplete="name" value={formState.name} onChange={handleChange} required /></div>
            <div className="contact-field"><label htmlFor="contact-email">Email</label><input id="contact-email" type="email" name="email" placeholder="you@example.com" autoComplete="email" value={formState.email} onChange={handleChange} required /></div>
            <div className="contact-field"><label htmlFor="contact-message">Project, idea, or business challenge</label><textarea id="contact-message" name="message" placeholder="Tell us what you want to build or improve" rows="7" value={formState.message} onChange={handleChange} required></textarea></div>
            <button type="submit" disabled={isSending} aria-busy={isSending}>{isSending ? 'Sending...' : 'Send Message'}</button>
            {status.message && <p id="contact-form-status" className={`contact-status ${status.type}`} role={status.type === 'error' ? 'alert' : 'status'}>{status.message}</p>}
          </form>
        </div>
      </div></section>
    </main>
  );
};

export default Contact;
